import axios from './axios'
import env from '../../scripts/common/env';

let instance = axios()

const apiConf = {
  // default
  dataGw: {
    apiHost: 'https://qceit-gw.youth.qq.com',
    testApiHost: 'https://test-qceit-gw.youth.qq.com',
    devApiHost: 'https://test-qceit-gw.youth.qq.com',
    // devApiHost: '//127.0.0.1:10002',
    apiUrl: null,
  },
  apiUrl: null, // default api cache
};

// 生成URL查询条件
// function serialize(query, type = '?') {
//   let urlText = ''
//   if (typeof query === 'object') {
//     Object.keys(query).forEach((key) => {
//       if (typeof query[key] !== 'undefined' && query[key] !== 'undefined' && query[key] !== '') {
//         if (type === '?') {
//           urlText += `&${key}=${query[key]}`
//         } else {
//           urlText += `/${key}/${query[key]}`
//         }
//       }
//     })
//   }
//   return urlText.replace(/^&/, '?')
// }

function handleUrl(url, option) {
  if (option && option.useApiConf) {
    if (!option.useApiConf.apiUrl) {
      if (env.getIsDevEnv()) {
        option.useApiConf.apiUrl = option.useApiConf.devApiHost;
      } else if (env.getIsTestEnv()) {
        option.useApiConf.apiUrl = option.useApiConf.testApiHost;
      } else {
        option.useApiConf.apiUrl = option.useApiConf.apiHost;
      }
    }
    return option.useApiConf.apiUrl + url;
  }
  if (!apiConf.apiUrl) {
    if (env.getIsDevEnv()) {
      apiConf.apiUrl = apiConf.dataGw.devApiHost;
    } else if (env.getIsTestEnv()) {
      apiConf.apiUrl = apiConf.dataGw.testApiHost;
    } else {
      apiConf.apiUrl = apiConf.dataGw.apiHost;
    }
  }
  return apiConf.apiUrl + url;
}

let store = null;

export function setStore(vStore) {
  store = vStore;
  console.log('--- setStore');
}

function handleHeader() {
  const token = store && store.get('token')
  if (token) {
    instance.defaults.headers.Authorization = token
  }
}

export default {
  httpGet(url, params, headers, option) {
    handleHeader()
    let options = {}

    if (params) {
      options.params = params
    }
    if (headers) {
      options.headers = headers
    }
    return instance.get(handleUrl(url, option), options)
  },
  httpPost(url, params, headers, option) {
    handleHeader()
    let options = {}

    // if (params) {
    //   options.params = params
    // }
    if (headers) {
      options.headers = headers
    }
    return instance.post(handleUrl(url, option), params, options)
  },
  httpPut(url, params, headers, option) {
    handleHeader()
    let options = {}

    if (headers) {
      options.headers = headers
    }
    return instance.put(handleUrl(url, option), params, options)
  },
  httpDelete(url, params, headers, option) {
    handleHeader()
    let options = {}

    if (params) {
      options.params = params
    }
    if (headers) {
      options.headers = headers
    }
    return instance.delete(handleUrl(url, option), options)
  }
}
